// Home.js
import React, {Component} from 'react';
import Firstapi from '../pages/Firstapi';
import Subscription from '../pages/Subscription';
import "../App.css";
import {Link} from 'react-router-dom';
import AdSense from 'react-adsense';
import Blogdata from '../pages/Blogdata';

export default class Home extends Component {
    componentDidMount () {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
    render(){
        return (
           <div>
            
<section className="container">
    <div className="row">
        <div className="col-sm-12">
            <ul className="breadcrumbs">
                <li><a href='https://www.intellisaving.com'>Home</a> <i className="fas fa-chevron-right"></i></li><li>Best Saving Rate</li>
            </ul>
        </div>
    </div>
</section>

<section className="section-pading">
    <div className="container">
        <div className="row">
            <div className="col-sm-12 col-md-5">
                <h1 className="banner-hding">Best Savings Accounts</h1>
                <p className="banner-prgh">IntelliSaving enables you to compare the best interest rate for different types of savings accounts, which helps you to choose the best products as per your need.</p>
               
            </div>
            <div className="col-sm-12 col-md-4">
                <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/banner-saving-img.png'} alt="banner" className="img-fluid banner-savingimg"/>
            </div>
            <div className="col-sm-12 col-md-3 pl-md-0">
                <div className="banner-advertisimg" width="300" height="250">
                    <ins className='adsbygoogle'
                     style={{ width: 300, height: 250 }}
                     data-ad-client="ca-pub-5162711024609714"
                     data-ad-slot="2150854768"></ins>
                </div></div></div></div></section>
<section className="section-pading pt-0">
    <div className="container">
        <div className="row">
            <div className="col-sm-12 col-md-6">
                <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/saving-rates.jpg'} alt="saving" className="img-fluid"/>
            </div>
            <div className="col-sm-12 col-md-6">
                <h4 className="saving-ratehding">Best Savings Rates as of Today</h4>
                <p className="saving-rateprgh">Find out which savings accounts are providing best interest rates in our Best Rate categories below.</p>
            </div>  
        </div>
    </div>  
</section>  

<Firstapi/>
<section className="">
    <div className="container">
        <div className="row">
            <div className="col-sm-12 mt-4" style={{fontSize: "12px"}}>
                <p><strong>Disclaimer: </strong> While we endeavour to deliver the latest up to date saving rates and charts on a regular occurrence, all the rates are subject to change by the providers or subsequently by us at any time without any notice. We strongly recommend reading the complete terms of the product with the selected provider before investing. This disclaimer must be read in conjunction with our <a href="https://www.intellisaving.com/terms">Terms of Service</a>. For any query or suggestion on the best saving rate offers or anything else related to IntelliSaving, please don’t hesitate to contact us at <a href="mailto:support@intellisaving.com">support@intellisaving.com</a></p>
            </div>
        </div>
    </div>
</section>
<Subscription/>

<section className="light-bg">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-sm-12">
                <div className="block-page-title-block">
                    <h1 className="page-title">IntelliSaving</h1>
                    <p className="py-4">IntelliSaving is an integrated platform to manage your savings bank accounts from your fingertips at one place. So, you do not need to track each saving account individually. Now, you can invest more time in making intelligent saving strategies and less time in tracking your money and market rates. See you save!!</p>
                </div>
            </div>
            <div className="col-xl-10">
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <div className="about-step-area">
                            <div className="about-leftshade"></div>
                            <div className="about-rightshade"></div>
                            <h3 className="about-circle-step">1</h3>
                            <p className="about-circle-botxt">Select saving provider</p>
                        </div>  
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="about-step-area">
                            <div className="about-leftshade"></div>
                            <div className="about-rightshade"></div>
                            <h3 className="about-circle-step">2</h3>
                            <p className="about-circle-botxt">Link your account and product</p>
                        </div>  
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="about-step-area">
                            <div className="about-leftshade"></div>
                            <div className="about-rightshade"></div>
                            <h3 className="about-circle-step">3</h3>
                            <p className="about-circle-botxt">See you save</p>
                        </div>  
                    </div>      
                </div>
            </div>
            <div className="col-sm-12 col-md-8 col-lg-7">
                <div className="row justify-content-center">
                    <div className="col-sm-5 col-md-7">
                        <p className="download-apptext">Download our app now</p>    
                    </div>
                    <div className="col-sm-5">
                        <div className="flex justify-content-center align-items-center">
                            <a href="https://apps.apple.com/gb/app/intellisaving/id1558506727" target="_blank"><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/app-store.png'} alt="app" className="mr-2"/></a>
                            <a href="https://play.google.com/store/apps/details?id=com.app.intellisaving" target="_blank"><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/g-play-store.png'} alt="g-play" className="mr-2"/></a>
                        </div>  
                    </div>
                </div>
            </div>  
        </div>
    </div>
</section>

<section className="section-pading">
    <div className="container">
        <div className="row">
            <div className="col-sm-12 col-md-12">
                <div className="block-page-title-block">
                    <h1 className="page-title">Type of Accounts</h1>
                </div>
            </div>
            <div className="col-sm-12 col-md-6">
                <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/type-of-account.png'} alt="type-of-account" className="img-fluid mb-3 mb-md-0 pt-2"/>
            </div>
            <div className="col-sm-12 col-md-6">
                <div className="block-page-title-block text-left mb-3 mb-md-4">
                    <p className="mb-2">IntelliSaving different types of Savings accounts to support your goals/purpose for saving. Find out below about the various saving accounts and start your saving journey.</p>
                    <p className="mb-0">Please note, IntelliSaving do not recommend any particular saving types, we promote the ethos of saving and let you choose the best for you.</p>
                </div>
                <div className="d-none d-lg-block">
                    <div className="row">
                        <div className="col-sm-6">
                            <ul className="type-aclist">
                                <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon1"/> Easy & Limited Access</li>
                                <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon2"/> Fixed Terms Bond</li>
                                <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon3"/> Tax-free Saving (ISA)</li>
                            </ul>
                        </div>
                        <div className="col-sm-6">
                            <ul className="type-aclist">
                                <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon4"/> Regular Saver</li>
                                <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon5"/> Notice Account</li>
                                <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon6"/> Junior & Children</li>
                            </ul>
                        </div>
                    </div>
                </div>  
            </div>  
            <div className="col-sm-12 col-md-12 offest-md-6 d-block d-lg-none">
                <div className="row">
                    <div className="col-sm-6">
                        <ul className="type-aclist">
                            <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon7"/> Easy & Limited Access</li>
                            <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon8"/> Fixed Terms Bond</li>
                            <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon9"/> Tax-free Saving (ISA)</li>
                        </ul>
                    </div>
                    <div className="col-sm-6">
                        <ul className="type-aclist">
                            <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon10"/> Regular Saver</li>
                            <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon11"/> Notice Account</li>
                            <li><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/file-icon.png'} alt="file-icon12"/> Junior & Children</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</section>
<section className="pos-section">
    <div className="container">
        <div className="row">
            <div className="col-sm-12 col-md-12">
                <div className="block-page-title-block">
                    <h1 className="page-title">Purpose of your saving</h1>
                </div>
            </div>
            <div className="col-sm-12 col-md-6">
                <div className="pos-area">
                    <div className="d-flex">
                        <div className="pos-img">
                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/deposit-icon.png'} alt="deposit-icon" />
                        </div>
                        <div className="pos-textarea">
                            <h5 className="pos-hding">Mortgage Deposit/Repayment</h5>
                            <p className="pos-prgh">Are you thinking of buying a house or repaying an existing loan? Regular saver accounts could be advantageous for this type of saving need because you are expected to save on a recurring monthly basis, helping you become more acquainted with saving if you are not much of a saver.</p>
                        </div>
                    </div>
                </div>  
            </div>  
            <div className="col-sm-12 col-md-6">
                <div className="pos-area">
                    <div className="d-flex">
                        <div className="pos-img">
                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/retirement-icon.png'} alt="retirement-icon" />
                        </div>
                        <div className="pos-textarea">
                            <h5 className="pos-hding">Retirement</h5>
                            <p className="pos-prgh">Are you thinking of saving for retirement? A fixed-interest rate is a good option as the interest rate doesn’t change, but you won’t have access to your account during the term. Fixed-rate interest accounts vary in length and lasts between a few months to a few years.</p>
                        </div>
                    </div>
                </div>  
            </div>  
            <div className="col-sm-12 col-md-6">
                <div className="pos-area">
                    <div className="d-flex">
                        <div className="pos-img">
                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/holiday-icon.png'} alt="holiday-icon" />
                        </div>
                        <div className="pos-textarea">
                            <h5 className="pos-hding">Family Holiday</h5>
                            <p className="pos-prgh">Family holidays can be expensive therefore saving in advance is crucial; many dreams of soaking up in the sun, but which accounts best match this saving requirement? The easy access could be ideal as you can access your account without being served any unwanted penalties.</p>
                        </div>
                    </div>
                </div>  
            </div>  
            
            <div className="col-sm-12 col-md-6">
                <div className="pos-area">
                    <div className="d-flex">
                        <div className="pos-img">
                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/tax-free-icon.png'} alt="tax-free-icon" />
                        </div>
                        <div className="pos-textarea">
                            <h5 className="pos-hding">Tax-free Savings</h5>
                            <p className="pos-prgh">Tax-free savings enable savers to earn interest on cash in their ISA without being charged tax on interest earned. Every tax year (runs from 6 April to 5 April) you can put money into one of each kind of ISA. Bank, building society and NS&I offer some specific Cash ISA and Junior ISA (for children under 18) products.</p>
                        </div>
                    </div>
                </div>  
            </div>  
            <div className="col-sm-12 col-md-6">
                <div className="pos-area">
                    <div className="d-flex">
                        <div className="pos-img">
                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/education-icon.png'} alt="education" />
                        </div>
                        <div className="pos-textarea">
                            <h5 className="pos-hding">Education</h5>
                            <p className="pos-prgh">University fees in the UK increased significantly over the last decade, making saving for education more challenging. Limited access accounts might work for you because you will be given access to your account, although access will be limited to a specific number of times.</p>
                        </div>
                    </div>
                </div>  
            </div>  
            <div className="col-sm-12 col-md-6">
                <div className="pos-area">
                    <div className="d-flex">
                        <div className="pos-img">
                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/deposit-icon.png'} alt="deposit" />
                        </div>
                        <div className="pos-textarea">
                            <h5 className="pos-hding">Starting A Family</h5>
                            <p className="pos-prgh">Starting a family can be a beautiful step in your next chapter, but what account would suit this requirement best? Easy access may be beneficial as you can tuck into your savings as often as needed as you most likely will want to buy essentials for your new arrival.</p>
                        </div>
                    </div>
                </div>  
            </div>  
        </div>
    </div>
</section>

<Blogdata/>

<section>
    <div className="container">
        <div className="row mb-4 pb-3">
            <div className="col-sm-12 col-md-12">
                <div className="socialarea">
                    <div className="row">
                        <div className="col-sm-5">
                            <p className="download-apptext">Find us over social media</p>
                        </div>
                        <div className="col-sm-7">
                            <div className="flex justify-content-center justify-content-md-end align-items-center">
                                <ul className="socialicon">
                                    <li><a href="https://www.facebook.com/intellisaving" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="https://twitter.com/intellisaving" target="_blank"><i className="fab fa-twitter"></i></a></li>
                                    <li><a href="https://www.linkedin.com/company/intellisaving/" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
                                    <li><a href="https://www.instagram.com/intellisaving/" target="_blank"><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
    </div>
</section>

<section className="container">
    <div className="row mt-3 mb-5 pb-4">
        <div className="col-sm-12">
            <div className="newsletter-area">
                <div className="row">
                    <div className="col-sm-5">
                        <p className="download-apptext">Download our app now</p>
                    </div>
                    <div className="col-sm-7">
                        <div className="d-flex justify-content-end">
                            <a href="https://apps.apple.com/gb/app/intellisaving/id1558506727" target="_blank"><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/app-store.png'} alt="app-store" className="mr-2"/></a>
                            <a href="https://play.google.com/store/apps/details?id=com.app.intellisaving" target="_blank"><img src={process.env.PUBLIC_URL + '/assets/sites/default/files/g-play-store.png'} alt="g-play-store" className="mr-2"/></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

</div>
        )

    }
}